import React from 'react';
import PropTypes from 'prop-types';

const getScript = content => ({
  __html: `<script type="application/ld+json">${JSON.stringify(content)}</script>`,
});

// eslint-disable-next-line react/no-danger
const JsonSchema = ({ content }) => <div dangerouslySetInnerHTML={getScript(content)} />;

JsonSchema.propTypes = {
  content: PropTypes.object,
};

export default JsonSchema;
